import { render, staticRenderFns } from "./PackagePage.vue?vue&type=template&id=2fa106cc&scoped=true"
import script from "./PackagePage.vue?vue&type=script&lang=js"
export * from "./PackagePage.vue?vue&type=script&lang=js"
import style0 from "./PackagePage.vue?vue&type=style&index=0&id=2fa106cc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa106cc",
  null
  
)

export default component.exports